import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";

import { CardProps, focus, InputTypes, setPlaceholder, setText, StateProps } from "../../store";
import * as S from "./styles";

const TextFieldSection = ({ id }: Pick<CardProps, "id">) => {
  const dispatch = useDispatch();
  const { control } = useForm();

  const inputType = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.inputType;
  }) as string;

  const isFocused = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.isFocused;
  }) as boolean;

  const handlePlaceholder = () => {
    if (inputType === InputTypes.TITLE) return "설문지 설명";
    if (inputType === InputTypes.TEXTAREA) return "장문형 텍스트 (예시 텍스트 입력 가능)";
    return "단답형 텍스트 (예시 텍스트 입력 가능)";
  };

  const placeholder = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.placeholder;
  }) as string;

  return (
    <Controller
      name="TextFieldInput"
      control={control}
      render={({ field: { onChange } }) => (
        <S.TextField
          placeholder={handlePlaceholder()}
          onChange={(e) => {
            onChange(e); // react-hook-form의 상태 업데이트
            dispatch(setPlaceholder({ cardId: id, text: e.target.value })); // Redux 상태 업데이트
          }}
          onClick={() => dispatch(focus({ id }))}
          id="standard-basic"
          variant="standard"
          $inputType={inputType}
          $isFocused={isFocused}
          value={placeholder}
        />
      )}
    />
  );
};

export default TextFieldSection;
